import { render, staticRenderFns } from "./GalleryView.vue?vue&type=template&id=3c88bf96&scoped=true"
import script from "./GalleryView.vue?vue&type=script&lang=js"
export * from "./GalleryView.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/GalleryView/GalleryView.less?vue&type=style&index=0&id=3c88bf96&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c88bf96",
  null
  
)

export default component.exports